import React from 'react'
import Loader from 'react-loader-spinner'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../stores/actionsList'
import { pathMaker } from '../utils/useful';

class PageStatusViewer extends React.Component {

    unauthorizedHandled = false

    componentDidMount() {
        this.handleUnauthorized(this.props.status)
    }

    componentDidUpdate(prevProps) {
        if (this.props.status !== prevProps.status) {
            this.handleUnauthorized(this.props.status)
        }
    }

    handleUnauthorized(status) {
        if (status !== 401 || this.unauthorizedHandled) return
        this.unauthorizedHandled = true
        this.props.actions.logoutUser()
        this.props.history.push(pathMaker('/login'))
    }

    render() {
        if (!this.props.status) {

            return (
                <div className="mt-5 text-center w-100">
                    <Loader
                        type={this.props.type ?? "Oval"}
                        color={this.props.color ?? "#202020"}
                        height={this.props.width ?? 50}
                        width={this.props.height ?? 50}
                    />
                </div>
            )
        }

        if (this.props.status == 401) {
            return (
                <div className="mt-5 text-center w-100">
                    <Loader
                        type={this.props.type ?? "Oval"}
                        color={this.props.color ?? "#202020"}
                        height={this.props.width ?? 50}
                        width={this.props.height ?? 50}
                    />
                </div>
            )
        }

        if (this.props.status == 200) {
            return this.props.children

        }

        if (this.props.status == 500) {
            return (
                <div className="text-center pt-5">
                    <p className="text-bold text-big mb-0">500</p>
                    <p className="text-uppercase mt-0">Server Error</p>
                </div>
            )

        }


        if (this.props.status == 404) {
            return (
                <div className="w-100 mt-5 text-center">
                    <h3 className=" text-ultra-big m-0">Page Not Found</h3>
                    <h3 className=" text-mega-big m-0">404</h3>
                </div>
            )
        }

    }
}

const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(null, mapDispatchToProps)(withRouter(PageStatusViewer));